<template>
    <div v-if="isShow" class="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex justify-center items-center z-50 transition-all duration-300">
        <div class="relative bg-white/95 backdrop-blur-md md:rounded-2xl shadow-2xl border border-white/20 md:w-[90%] md:max-h-[85%] w-full h-full md:h-auto flex flex-col overflow-hidden"
            :class="{ 'animate-popupFadeIn': isVisible, 'animate-popupFadeOut': !isVisible }">
            <!-- Popup content -->
            <h2 class="relative w-full bg-brand p-4 text-center text-yellow-500 font-bold text-[16px] tracking-wide z-50 flex-shrink-0" style="background-color: var(--color-brand);">
                {{ nameHeader }}
                <div class="absolute right-4 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-white/10 hover:bg-red-500 text-white/90 hover:text-white transition-colors flex items-center justify-center cursor-pointer shadow-sm" @click="closeModal()">
                    <font-awesome-icon :icon="['fas', 'xmark']" />
                </div>
            </h2>
            <div class="relative w-full overflow-y-auto overflow-x-hidden no-scrollbar flex-1">
                <!-- Wrapper -->
                <div class="flex transition-transform duration-500 h-full"
                    :style="{ transform: `translateX(-${currentIndex * 100}%)` }" ref="scrollWrapper">
                    <div class="w-full flex-shrink-0" ref="page1">
                        <div class="p-6">
                            <button v-if="selectedBillType === 1 && billOption === 3" @click="changePage(1)"
                                class="py-2 cursor-pointer text-[14px] text-right hover:text-blue-500 border-2 rounded-md px-2 mb-2">
                                <font-awesome-icon :icon="['fas', 'table']" /> Nhập bảng kê chi phí
                            </button>
                            <button v-if="selectedBillType === 1 && billOption === 1" @click="changePage(1)"
                                class="py-2 cursor-pointer text-[14px] text-right hover:text-blue-500 border-2 rounded-md px-2 mb-2">
                                <font-awesome-icon :icon="['fas', 'table']" /> Nhập bảng THCP
                            </button>
                            <button v-if="selectedBillType === 3" @click="changePage(1)"
                                class="py-2 cursor-pointer text-[14px] text-right hover:text-blue-500 border-2 rounded-md px-2 mb-2">
                                <font-awesome-icon :icon="['fas', 'table']" /> Nhập bảng tạm ứng
                            </button>
                            <div class="grid grid-cols-2 gap-4 mb-2">
                                <div>
                                    <span class="text-sm font-semibold text-gray-700 block mb-2">Mã phiếu <span class="text-red-500">*</span> </span>
                                    <input type="text" v-model="code" placeholder="Nếu không nhập mã sẽ tự động tạo"
                                        class="h-[44px] border border-gray-200 bg-gray-50 rounded-xl focus:border-brand focus:ring-2 focus:ring-brand/20 focus:bg-white w-full focus:outline-none px-4 text-[14px] text-gray-800 transition-all shadow-inner hover:bg-gray-100">
                                </div>
                                <div>
                                    <span for="billType" class="text-sm font-semibold text-gray-700 block mb-2">Loại phiếu <span class="text-red-500">*</span> </span>
                                    <div class="relative">
                                        <select id="billType"
                                            class="h-[44px] border border-gray-200 bg-gray-50 rounded-xl focus:border-brand focus:ring-2 focus:ring-brand/20 focus:bg-white w-full focus:outline-none px-4 text-[14px] text-gray-800 transition-all shadow-inner hover:bg-gray-100 appearance-none"
                                            v-model="selectedBillType">
                                            <option v-for="type in fillterBillTypesData" :key="type.value"
                                                :value="type.value">
                                                {{ type.label }}
                                            </option>
                                        </select>
                                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-gray-500">
                                            <font-awesome-icon :icon="['fas', 'chevron-down']" class="text-xs" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="grid grid-cols-2 gap-4 mb-4 mt-4">
                                <div>
                                    <div class="text-sm font-semibold text-gray-700 block mb-2">Nhóm phiếu</div>
                                    <div class="relative">
                                        <select id="billType"
                                            class="h-[44px] border border-gray-200 bg-gray-50 rounded-xl focus:border-brand focus:ring-2 focus:ring-brand/20 focus:bg-white w-full focus:outline-none px-4 text-[14px] text-gray-800 transition-all shadow-inner hover:bg-gray-100 appearance-none"
                                            v-model="billOption">
                                            <option v-for="type in listBillOption" :key="type.value" :value="type.value">
                                                {{ type.text }}
                                            </option>
                                        </select>
                                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-gray-500">
                                            <font-awesome-icon :icon="['fas', 'chevron-down']" class="text-xs" />
                                        </div>
                                    </div>
                                </div>
                                <div v-if="$app.userInfo.departments.length > 1">
                                    <div class="text-sm font-semibold text-gray-700 block mb-2">Chọn bộ phận <span class="text-red-500">*</span></div>
                                    <div class="relative">
                                        <select id="billType"
                                            class="h-[44px] border border-gray-200 bg-gray-50 rounded-xl focus:border-brand focus:ring-2 focus:ring-brand/20 focus:bg-white w-full focus:outline-none px-4 text-[14px] text-gray-800 transition-all shadow-inner hover:bg-gray-100 appearance-none"
                                            v-model="selectedDepartment" placeholder="Chọn bộ phân tạo phiếu"
                                            :default-first-option="true">
                                            <option v-for="(department, index) in $app.userInfo.departments" :key="index"
                                                :value="department.id">
                                                {{ department.name }}
                                            </option>
                                        </select>
                                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-gray-500">
                                            <font-awesome-icon :icon="['fas', 'chevron-down']" class="text-xs" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="Number(billOption) === 8" class="mb-4">
                                <span class="text-sm font-semibold text-gray-700 block mb-2">Tên nhóm phiếu khác <span class="text-red-500">*</span></span>
                                <input type="text" v-model="otherFormOfBill" placeholder="Nhập tên nhóm phiếu..."
                                    :class="{ 'border-red-500 focus:ring-red-500/20': errors.otherFormOfBill }"
                                    class="h-[44px] border border-gray-200 bg-gray-50 rounded-xl focus:border-brand focus:ring-2 focus:ring-brand/20 focus:bg-white w-full focus:outline-none px-4 text-[14px] text-gray-800 transition-all shadow-inner hover:bg-gray-100">
                                <p v-if="errors.otherFormOfBill" class="text-red-500 text-xs mt-1">{{ errors.otherFormOfBill }}</p>
                            </div>
                            <div v-if="billOption === 4 && selectedBillType === 1">
                                <div class="text-[15px] font-bold text-gray-800 border-b border-gray-100 pb-2 mb-4 mt-6">Bên A : (Bên mua)</div>
                                <div class="my-4">
                                    <div class="text-sm font-semibold text-gray-700 block mb-2">Công ty <span class="text-red-500">*</span></div>
                                    <div class="relative">
                                        <select v-model="selectedCompany"
                                            class="h-[44px] border border-gray-200 bg-gray-50 rounded-xl focus:border-brand focus:ring-2 focus:ring-brand/20 focus:bg-white w-full focus:outline-none px-4 text-[14px] text-gray-800 transition-all shadow-inner hover:bg-gray-100 appearance-none">
                                            <option v-for="item in companies" :key="item.value" :value="item.name">
                                                {{ item.name }}
                                            </option>
                                        </select>
                                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-gray-500">
                                            <font-awesome-icon :icon="['fas', 'chevron-down']" class="text-xs" />
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="my-2">
                                    <div>Họ và Tên <span class="text-red-500">*</span></div>
                                    <input type="text" placeholder="Nhập họ và tên"
                                        class="h-14 w-[100%] border-[1px] mt-2 p-2 rounded-md focus:border-blue-500 focus:outline-none ">
                                </div> -->
                                <div class="grid grid-cols-2 gap-4 mb-4">
                                    <div>
                                        <div class="text-sm font-semibold text-gray-700 block mb-2">Số CT</div>
                                        <input v-model="companyNumber" type="text" placeholder="Nhập số ct"
                                            class="h-[44px] border border-gray-200 bg-gray-50 rounded-xl focus:border-brand focus:ring-2 focus:ring-brand/20 focus:bg-white w-full focus:outline-none px-4 text-[14px] text-gray-800 transition-all shadow-inner hover:bg-gray-100">
                                    </div>
                                    <div>
                                        <div class="text-sm font-semibold text-gray-700 block mb-2">Ngày</div>
                                        <input type="datetime-local" v-model="nowDateTime"
                                            class="h-[44px] border border-gray-200 bg-gray-50 rounded-xl focus:border-brand focus:ring-2 focus:ring-brand/20 focus:bg-white w-full focus:outline-none px-4 text-[14px] text-gray-800 transition-all shadow-inner hover:bg-gray-100">
                                    </div>
                                    <div class="col-span-2">
                                        <div class="text-sm font-semibold text-gray-700 block mb-2">Loại HH</div>
                                        <input type="text" placeholder="Nhập loại hàng hoá" v-model="typeOfGoods"
                                            class="h-[44px] border border-gray-200 bg-gray-50 rounded-xl focus:border-brand focus:ring-2 focus:ring-brand/20 focus:bg-white w-full focus:outline-none px-4 text-[14px] text-gray-800 transition-all shadow-inner hover:bg-gray-100">
                                    </div>
                                </div>
                                <div class="text-[15px] font-bold text-gray-800 border-b border-gray-100 pb-2 mb-4 mt-6">Bên B : (Bên bán)</div>
                                <div class="my-4">
                                    <div class="text-sm font-semibold text-gray-700 block mb-2">Nhà cung cấp <span class="text-red-500">*</span></div>
                                    <input v-model="supplier" type="text" placeholder="Nhập tên nhà cung cấp"
                                        class="h-[44px] border border-gray-200 bg-gray-50 rounded-xl focus:border-brand focus:ring-2 focus:ring-brand/20 focus:bg-white w-full focus:outline-none px-4 text-[14px] text-gray-800 transition-all shadow-inner hover:bg-gray-100">
                                </div>
                                <div class="my-4">
                                    <div class="text-sm font-semibold text-gray-700 block mb-2">Địa chỉ <span class="text-red-500">*</span></div>
                                    <input v-model="supplierAddress" type="text" placeholder="Nhập địa chỉ nhà cung cấp"
                                        class="h-[44px] border border-gray-200 bg-gray-50 rounded-xl focus:border-brand focus:ring-2 focus:ring-brand/20 focus:bg-white w-full focus:outline-none px-4 text-[14px] text-gray-800 transition-all shadow-inner hover:bg-gray-100">
                                </div>
                                <div class="my-4">
                                    <div class="text-sm font-semibold text-gray-700 block mb-2">Hình thức T/T:</div>
                                    <div class="relative">
                                        <select
                                            class="h-[44px] border border-gray-200 bg-gray-50 rounded-xl focus:border-brand focus:ring-2 focus:ring-brand/20 focus:bg-white w-full focus:outline-none px-4 text-[14px] text-gray-800 transition-all shadow-inner hover:bg-gray-100 appearance-none"
                                            v-model="selectedOptionPayment">
                                            <option value="1">Tiền mặt</option>
                                            <option value="2">Ngân hàng</option>
                                        </select>
                                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-gray-500">
                                            <font-awesome-icon :icon="['fas', 'chevron-down']" class="text-xs" />
                                        </div>
                                    </div>
                                </div>
                                <div class="my-4" v-if="selectedOptionPayment === '2'">
                                    <div class="grid grid-cols-2 gap-4 my-4">
                                        <div>
                                            <div>Tên tài khoản <span class="text-red-500">*</span></div>
                                            <input type="text" placeholder="Tên chủ tài khoản"
                                                v-model="$app.userInfo.bankAccountName"
                                                :class="{ 'border-red-500': errors.accountname }"
                                                class="h-14 w-[100%] border-[1px] p-2 rounded-md focus:border-blue-500 focus:outline-none ">
                                            <p v-if="errors.accountname" class="text-red-500 text-sm">{{
                                                errors.accountname
                                                }}
                                            </p>
                                        </div>
                                        <div>
                                            <div>Số tài khoản <span class="text-red-500">*</span></div>
                                            <input type="text" placeholder="Số tài khoản"
                                                v-model="$app.userInfo.bankAccountNumber"
                                                :class="{ 'border-red-500': errors.accountnumber }"
                                                class="h-14 w-[100%] border-[1px] p-2 rounded-md focus:border-blue-500 focus:outline-none ">
                                            <p v-if="errors.accountnumber" class="text-red-500 text-sm">{{
                                                errors.accountnumber
                                                }}
                                            </p>
                                        </div>
                                    </div>
                                    <div>
                                        <div>Ngân hàng <span class="text-red-500">*</span></div>
                                        <input type="text"
                                            class="h-14 w-[100%] border-[1px] p-2 rounded-md focus:border-blue-500 focus:outline-none"
                                            :class="{ 'border-red-500': errors.bankname }"
                                            v-model="$app.userInfo.bankName" placeholder="Tên ngân hàng">
                                        <p v-if="errors.bankname" class="text-red-500 text-sm">{{ errors.bankname }}</p>
                                    </div>
                                </div>
                                <div class="text-[15px] font-bold text-gray-800 border-b border-gray-100 pb-2 mb-4 mt-6">Nội dung :</div>
                                <div class="overflow-x-auto my-2 border border-gray-200 rounded-xl shadow-sm">
                                    <table class="w-full text-sm text-left">
                                        <thead class="bg-gray-50 text-gray-700 font-semibold border-b border-gray-200">
                                            <tr class="text-center">
                                                <td class="p-3 border-r border-gray-200 last:border-r-0">STT</td>
                                                <td class="p-3 border-r border-gray-200 last:border-r-0">Ngày CT</td>
                                                <td class="p-3 border-r border-gray-200 last:border-r-0 w-[40%]">Diễn giải</td>
                                                <td class="p-3 border-r border-gray-200 last:border-r-0 w-[20%]">Tổng thanh toán</td>
                                            </tr>
                                        </thead>
                                        <tbody class="divide-y divide-gray-200 text-gray-800 bg-white">
                                            <tr class="text-center hover:bg-gray-50 transition-colors" v-for="(item, index) in detailPayment" :key="index">
                                                <td class="p-2 border-r border-gray-200 last:border-r-0">{{ index + 1 }}</td>
                                                <td class="p-2 border-r border-gray-200 last:border-r-0">
                                                    <input type="date" v-model="item.date"
                                                        class="w-full bg-white border border-gray-200 p-1.5 focus:bg-white text-sm focus:ring-1 focus:ring-brand focus:border-brand rounded-lg outline-none transition-all" />
                                                </td>
                                                <!-- <td class="border border-gray-300 p-2">
                                                    <input type="text" v-model="item.detail"
                                                        class="w-full border rounded p-1 text-sm focus:border-blue-500 focus:outline-none" />
                                                </td> -->
                                                <td class="p-2 relative border-r border-gray-200 last:border-r-0">
                                                    <input type="text" v-model="item.detail"
                                                        class="w-full bg-white border border-gray-200 p-1.5 focus:bg-white text-sm focus:ring-1 focus:ring-brand focus:border-brand rounded-lg outline-none transition-all"
                                                        @input="onInput(item)" @focus="onFocus(item)" @blur="onBlur" placeholder="Nhập tên nhà cung cấp..." />

                                                    <!-- Danh sách gợi ý -->
                                                    <ul v-if="showSuggestions && activeItem === item"
                                                        class="absolute z-10 left-0 mt-1 bg-white border border-gray-200 w-full max-h-40 overflow-auto shadow-lg rounded-xl">
                                                        <li v-for="supplier in filteredSuppliers" :key="supplier.code"
                                                            @mousedown.prevent="selectSupplier(item, supplier)"
                                                            class="px-3 py-2 text-left hover:bg-brand/5 cursor-pointer text-gray-700 transition-colors">
                                                            {{ supplier.code }} - {{ supplier.name }}
                                                        </li>
                                                        <li v-if="filteredSuppliers.length === 0"
                                                            class="px-3 py-2 text-left text-gray-400 italic">
                                                            Không có kết quả
                                                        </li>
                                                    </ul>
                                                </td>
                                                <td class="p-2 border-r border-gray-200 last:border-r-0">
                                                    <div class="flex items-center gap-2">
                                                        <input @keypress="onlyNumber" :value="formatNumber(item.money)"
                                                            @input="updateMoneyItemInDetailPayment($event, index)"
                                                            class="w-full bg-white border border-gray-200 p-1.5 focus:bg-white text-sm text-right focus:ring-1 focus:ring-brand focus:border-brand rounded-lg outline-none transition-all font-medium" />
                                                        <button v-if="detailPayment.length > 1"
                                                            @click="detailPayment.splice(index, 1)"
                                                            class="text-red-400 hover:text-red-600 transition-colors bg-red-50 hover:bg-red-100 p-1.5 rounded-lg shrink-0" title="Xóa dòng này">
                                                            <font-awesome-icon :icon="['fas', 'trash']" />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="4"
                                                    class="p-3 text-center font-semibold text-brand cursor-pointer hover:bg-brand/5 transition-colors"
                                                    @click="addDetailPayment">
                                                    <font-awesome-icon :icon="['fas', 'plus']" class="mr-1" /> Thêm dòng
                                                </td>
                                            </tr>
                                            <tr class="text-right bg-gray-50 font-semibold text-gray-800">
                                                <td colspan="3" class="p-3 border-r border-gray-200">Tổng cộng</td>
                                                <td class="p-3 text-brand">{{
                                                    formatNumber(getTotalMoney(detailPayment))
                                                    }}</td>
                                            </tr>

                                            <tr class="text-center">
                                                <td colspan="3" class="border border-gray-300 p-2">Tổng tiền thanh toán
                                                </td>
                                                <td class="border border-gray-300 p-2">{{
                                                    formatNumber(getTotalMoney(detailPayment))
                                                    }}</td>
                                            </tr>
                                            <tr class="text-center">
                                                <td colspan="2" class="border border-gray-300 p-2">Bằng chữ :</td>
                                                <td colspan="2" class="border border-gray-300 p-2">{{
                                                    convertToWords(getTotalMoney(detailPayment)) }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div v-else>
                                <div class="my-2">
                                    <span for="billType">Kính gửi công ty <span class="text-red-500">*</span> </span>
                                    <!-- <input v-model="company" type="text"
                                        placeholder="Tên công ty sẽ mặc định là HIGHLAND AGRI nếu không nhập"
                                        class="h-14 w-[100%] border-[1px] mt-2 p-2 rounded-md focus:border-blue-500 focus:outline-none "> -->
                                    <select v-model="selectedCompany"
                                        class="h-14 w-[100%] border-[1px] mt-2 p-2 rounded-md focus:border-blue-500 focus:outline-none">
                                        <option v-for="item in companies" :key="item.value" :value="item.name">
                                            {{ item.name }}
                                        </option>
                                    </select>
                                </div>
                                <div class="my-2">
                                    <div>Trả bằng:</div>
                                    <div class="grid grid-cols-2 gap-4 mt-2">
                                        <label class="flex items-center">
                                            <input type="radio" value="1" v-model="selectedOptionPayment"
                                                class="form-radio h-4 w-4 text-indigo-600 focus:ring-indigo-500" />
                                            <span class="ml-2 text-sm text-gray-700">Tiền mặt</span>
                                        </label>
                                        <label class="flex items-center">
                                            <input type="radio" value="2" v-model="selectedOptionPayment"
                                                class="form-radio h-4 w-4 text-indigo-600 focus:ring-indigo-500" />
                                            <span class="ml-2 text-sm text-gray-700">Ngân hàng</span>
                                        </label>
                                    </div>
                                    <div class="my-2">Số tiền:</div>
                                    <div class="col-span-4">
                                        <input type="text" :value="formatNumber(Math.floor(money))" @input="updateTotal"
                                            @keypress="onlyNumber" placeholder="Nhập số tiền"
                                            :disabled="(selectedBillType === 1 && billOption === 3) || (selectedBillType === 1 && billOption === 1)"
                                            :class="[
                                                'h-14 w-[100%] text-right text-[20px] font-bold mt-2 border-[1px] p-2 rounded-md focus:border-blue-500 focus:outline-none',
                                                { 'border-red-500': errors.money }
                                            ]" />

                                        <p v-if="errors.money" class="text-red-500 text-sm">{{ errors.money }}</p>
                                        <p v-if="money" class="text-right"><i>{{ moneyInWords }}</i></p>
                                    </div>

                                </div>
                                <div class="my-4" v-if="selectedOptionPayment === '2'">
                                    <div class="grid grid-cols-2 gap-4 my-4">
                                        <div>
                                            <div>Tên tài khoản <span class="text-red-500">*</span></div>
                                            <input type="text" placeholder="Tên chủ tài khoản"
                                                v-model="$app.userInfo.bankAccountName"
                                                :class="{ 'border-red-500': errors.accountname }"
                                                class="h-14 w-[100%] border-[1px] p-2 rounded-md focus:border-blue-500 focus:outline-none ">
                                            <p v-if="errors.accountname" class="text-red-500 text-sm">{{
                                                errors.accountname
                                                }}
                                            </p>
                                        </div>
                                        <div>
                                            <div>Số tài khoản <span class="text-red-500">*</span></div>
                                            <input type="text" placeholder="Số tài khoản"
                                                v-model="$app.userInfo.bankAccountNumber"
                                                :class="{ 'border-red-500': errors.accountnumber }"
                                                class="h-14 w-[100%] border-[1px] p-2 rounded-md focus:border-blue-500 focus:outline-none ">
                                            <p v-if="errors.accountnumber" class="text-red-500 text-sm">{{
                                                errors.accountnumber
                                                }}
                                            </p>
                                        </div>
                                    </div>
                                    <div>
                                        <div>Ngân hàng <span class="text-red-500">*</span></div>
                                        <input type="text"
                                            class="h-14 w-[100%] border-[1px] p-2 rounded-md focus:border-blue-500 focus:outline-none"
                                            :class="{ 'border-red-500': errors.bankname }"
                                            v-model="$app.userInfo.bankName" placeholder="Tên ngân hàng">
                                        <p v-if="errors.bankname" class="text-red-500 text-sm">{{ errors.bankname }}</p>
                                    </div>
                                </div>
                                <div class="my-4">
                                    <div class="text-sm font-semibold text-gray-700 block mb-2">Diễn giải <span class="text-red-500">*</span></div>
                                    <textarea name="long-text" id="1" placeholder="Diễn giải chi tiết"
                                        v-model="interpretation" :class="{ 'border-red-500 focus:ring-red-500/20': errors.interpretation }"
                                        class="w-full p-4 border border-gray-200 bg-gray-50 rounded-xl focus:border-brand focus:ring-2 focus:ring-brand/20 focus:bg-white focus:outline-none text-[14px] text-gray-800 transition-all shadow-inner hover:bg-gray-100 min-h-[100px]"></textarea>
                                    <p v-if="errors.interpretation" class="text-red-500 text-xs mt-1">{{
                                        errors.interpretation }}
                                    </p>
                                </div>
                                <div class="md:grid md:grid-cols-2 md:gap-4 my-4">
                                    <div class="md:my-0 my-2">
                                        <div class="text-sm font-semibold text-gray-700 block mb-2">Thời gian</div>
                                        <input type="datetime-local"
                                            class="h-[44px] border border-gray-200 bg-gray-50 rounded-xl focus:border-brand focus:ring-2 focus:ring-brand/20 focus:bg-white w-full focus:outline-none px-4 text-[14px] text-gray-800 transition-all shadow-inner hover:bg-gray-100"
                                            v-model="nowDateTime">
                                    </div>
                                </div>
                                <div v-if="billOption === 1 || billOption === 3" class="my-4">
                                    <div class="text-sm font-semibold text-gray-700 block mb-2">Địa chỉ <span class="text-red-500">*</span></div>
                                    <div class="relative inline-block w-full">
                                        <input type="text"
                                            class="h-[44px] border border-gray-200 bg-gray-50 rounded-xl focus:border-brand focus:ring-2 focus:ring-brand/20 focus:bg-white w-full focus:outline-none px-4 text-[14px] text-gray-800 transition-all shadow-inner hover:bg-gray-100 pointer-events-none"
                                            v-if="billOption === 1 || billOption === 3" v-model="fullbranchaddress"
                                            placeholder="Địa chỉ chi nhánh cửa hàng"
                                            :class="{ 'border-red-500 focus:ring-red-500/20': errors.fullbranchaddress }">
                                        <button @click="showListAddessPopup()"
                                            class="absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer"></button>
                                    </div>
                                    <p v-if="errors.fullbranchaddress" class="text-red-500 text-xs mt-1">{{
                                        errors.fullbranchaddress
                                        }}
                                    </p>
                                </div>
                            </div>
                            <div class="md:mt-6 mt-4">
                                <span class="text-sm font-semibold text-gray-700 block mb-2">File đính kèm <span class="text-red-500">*</span></span>
                            </div>

                            <div class="relative inline-block w-full mb-2">
                                <div
                                    class="w-full p-4 border-2 border-dashed border-brand/40 rounded-xl text-brand font-semibold bg-brand/5 hover:bg-brand hover:text-white transition-all duration-300 flex items-center justify-center gap-2 cursor-pointer shadow-sm">
                                    <font-awesome-icon :icon="['fas', 'cloud-arrow-up']" class="text-xl" /> 
                                    <span>Kéo thả hoặc nhấp để tải file lên</span>
                                </div>
                                <input type="file" multiple
                                    class="absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer"
                                    @change="handleFileUpload" :class="{ 'border-red-500': errors.selectedFile }" />
                            </div>

                            <p v-if="errors.selectedFile" class="text-red-500 text-xs mb-2">
                                {{ errors.selectedFile }}
                            </p>

                            <!-- Danh sách file đã chọn -->
                            <div v-if="selectedFile.length" class="space-y-2 mb-2">
                                <div v-for="(file, index) in selectedFile" :key="index"
                                    class="flex items-center justify-between border border-gray-100 bg-gray-50/80 px-4 py-2.5 rounded-xl shadow-sm hover:shadow-md transition-shadow">
                                    <div class="flex items-center gap-3 overflow-hidden">
                                        <div class="w-8 h-8 rounded-lg bg-white shadow-sm flex items-center justify-center text-brand shrink-0 border border-gray-100">
                                            <font-awesome-icon :icon="['fas', 'file-lines']" />
                                        </div>
                                        <span class="truncate text-sm font-medium text-gray-700">{{ file.name }}</span>
                                    </div>
                                    <button
                                        class="text-gray-400 hover:text-red-500 hover:bg-red-50 p-2 rounded-lg transition-colors shrink-0"
                                        @click="removeSelectedFile(index)" title="Xoá file">
                                        <font-awesome-icon :icon="['fas', 'trash']" />
                                    </button>
                                </div>
                            </div>

                            <!-- Danh sách file đã upload từ billdetail -->
                            <div v-if="billdetail && billdetail.attachedfile && billdetail.attachedfile.length" class="space-y-2 mb-2">
                                <div v-for="(file, index) in billdetail.attachedfile" :key="index"
                                    class="flex items-center justify-between border border-gray-100 bg-gray-50/80 px-4 py-2.5 rounded-xl shadow-sm hover:shadow-md transition-shadow">
                                    <div class="flex items-center gap-3 overflow-hidden">
                                        <div class="w-8 h-8 rounded-lg bg-white shadow-sm flex items-center justify-center text-brand shrink-0 border border-gray-100">
                                            <font-awesome-icon :icon="['fas', 'file-lines']" />
                                        </div>
                                        <span class="truncate text-sm font-medium text-gray-700">{{ file.name }}</span>
                                    </div>
                                    <button
                                        class="text-gray-400 hover:text-red-500 hover:bg-red-50 p-2 rounded-lg transition-colors shrink-0"
                                        @click="removeUploadedFile(file, index)" title="Xoá file">
                                        <font-awesome-icon :icon="['fas', 'trash']" />
                                    </button>
                                </div>
                            </div>

                            <div class="text-[12px] md:my-0 my-4">File dung lượng tối đa {{ maxSizeFileNumber }}MB</div>

                        </div>
                    </div>
                    <div class="w-full flex-shrink-0" ref="page2">
                        <div v-if="selectedBillType === 1 && billOption === 3">
                            <div class="p-6 pt-0">
                                <button @click="changePage(0)"
                                    class="py-2 cursor-pointer text-[14px] text-right hover:text-blue-500 border-2 rounded-md px-2 my-2">
                                    <font-awesome-icon :icon="['fas', 'backward']" /> Trở về trang phiếu
                                </button>
                                <TableKitchenForm v-model="products" :productsItem="productsItem"
                                    @update-total="handleAutoMoney" />
                            </div>
                        </div>
                        <div v-else-if="selectedBillType === 3">
                            <div class="p-6 pt-0">
                                <button @click="changePage(0)"
                                    class="py-2 cursor-pointer text-[14px] text-right hover:text-blue-500 border-2 rounded-md px-2 my-2">
                                    <font-awesome-icon :icon="['fas', 'backward']" /> Trở về trang phiếu
                                </button>
                                <TableRefundForm v-model="advanceProducts" />
                            </div>
                        </div>
                        <div v-else-if="selectedBillType === 1 && billOption === 1">
                            <div class="p-6 pt-0">
                                <button @click="changePage(0)"
                                    class="py-2 cursor-pointer text-[14px] text-right hover:text-blue-500 border-2 rounded-md px-2 my-2">
                                    <font-awesome-icon :icon="['fas', 'backward']" /> Trở về trang phiếu
                                </button>
                                <TableStoreForm v-model="productsSummary" :productsItem="productsItem"
                                    @update-total="handleAutoMoney" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="fix sticky bottom-0 w-full flex items-center relative p-4 border-t border-gray-100 bg-white/95 backdrop-blur-md md:rounded-b-2xl shadow-[0_-4px_10px_rgba(0,0,0,0.02)]">
                <!-- Checkbox sát trái -->
                <div class="absolute left-4 flex gap-4">
                    <el-checkbox v-model="reviewed" class="font-semibold text-gray-700"
                        v-if="this.$app.userInfo.user_role.value === 3 && this.$app.userInfo.departments?.some(el => el.value === 3) || this.$app.userInfo.user_role.value === 1">
                        ĐÃ RÀ SOÁT
                    </el-checkbox>
                </div>

                <!-- Nhóm nút nằm chính giữa -->
                <div class="mx-auto flex items-center gap-3">
                    <button v-if="isloading"
                        class="min-w-[120px] py-2.5 px-6 text-white font-bold rounded-xl bg-gray-400 cursor-not-allowed flex items-center justify-center shadow-sm">
                        <p class="flex text-sm items-center gap-2">
                            <svg class="size-4 animate-spin" viewBox="0 0 24 24">
                                <font-awesome-icon :icon="['fas', 'spinner']" />
                            </svg> Đang tải
                        </p>
                    </button>

                    <button v-else
                        class="min-w-[120px] py-2.5 px-6 bg-brand text-white font-bold rounded-xl shadow-[0_4px_10px_rgba(2,75,179,0.3)] hover:-translate-y-[1px] hover:bg-brand-light hover:shadow-[0_6px_14px_rgba(2,75,179,0.4)] transition-all flex justify-center items-center"
                        @click="validateForm()">
                        <p>{{ btnName }}</p>
                    </button>

                    <button @click="closeModal()"
                        class="min-w-[100px] py-2.5 px-6 font-bold rounded-xl border border-gray-200 text-gray-600 bg-white hover:bg-gray-50 hover:text-gray-900 transition-colors shadow-sm flex justify-center items-center">
                        Đóng
                    </button>
                </div>
            </div>

        </div>
        <ListAddress v-if="isShowListAddress" :isShow="isShowListAddress" @closed="isShowListAddress = false"
            @updateAddress="onUpdateAddress" />
    </div>
</template>

<script>
import { onlyNumber, formatNumber, unformatNumber } from '@/utils/onlyNum';
import TableKitchenForm from '../tableform/TableKitchenForm.vue';
import TableRefundForm from '../tableform/TableRefundForm.vue';
import TableStoreForm from '../tableform/TableStoreForm.vue';
import ListAddress from './ListAddress.vue';
import moment from 'moment'
import { Checkbox } from 'element-ui';

const API_URL = process.env.VUE_APP_API_URL

export default {
    components: {
        ListAddress,
        TableKitchenForm,
        TableRefundForm,
        TableStoreForm
    },
    props: {
        isShow: {
            type: Boolean,
            default: false,
        },
        nameHeader: {
            type: String,
            default: "",
        },
        typePopup: {
            type: String,
            default: 'Created'
        },
        billdetail: {
            type: Object,
            default: () => ({})
        },
        isHDHLMode: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectedDepartment: null,
            code: '',
            selectedOptionpuplic: "1",
            selectedOptionPayment: "1",
            options: [],
            isVisible: true,
            nowDateTime: "",
            otherFormOfBill: "",
            money: '',
            interpretation: '',
            accountname: this.$app.userInfo.bankAccountName,
            accountnumber: this.$app.userInfo.bankAccountNumber,
            bankname: this.$app.userInfo.bankName,
            branchaddress: '',
            fullbranchaddress: '',
            branchCode: '',
            storeCode: '',
            selectedFile: [],
            phonenumber: '',
            listAddress: [],
            detailPayment: [
                {
                    date: new Date().toISOString().slice(0, 10),
                    detail: '',
                    money: ''
                }
            ],
            products: [{ detail: "", money: "", date: new Date().toISOString().slice(0, 10), unit: "", quantity: 0, price: 0, note: "" }],
            advanceProducts: {
                AdvanceMoney: {
                    money: '',
                    note: ''
                },
                SpentMoney: [
                    { detail: '', money: 0, note: '' }
                ],
                noteRemainingAdvance: '',
                noteExcessAdvance: ''
            },
            productsSummary: {
                totalNote: '',
                totalInventoryMaterials: [
                    { date: new Date().toISOString().slice(0, 10), detail: '', unit: '', quantity: 0, price: 0, money: 0, note: '' }
                ],
                totalCeremonyMaterials: [
                    { date: new Date().toISOString().slice(0, 10), detail: '', unit: '', quantity: 0, price: 0, money: 0, note: '' }
                ],
                totalNonInventoryMaterials: [
                    { date: new Date().toISOString().slice(0, 10), detail: '', unit: '', quantity: 0, price: 0, money: 0, note: '' }
                ],
                totalOther: [
                    { date: new Date().toISOString().slice(0, 10), detail: '', unit: '', quantity: 0, price: 0, money: 0, note: '' }
                ]
            },
            billOption: 2,
            isloading: false,
            errors: {},
            isShowListAddress: false,
            MAX_SIZE: 3 * 1024 * 1024,
            filesContainer: [],
            btnName: '',
            selectedBillType: 1,
            currentIndex: 0,
            filteredProducts: [],
            company: "",
            companyNumber: "",
            typeOfGoods: "",
            supplier: "",
            supplierAddress: "",
            newData: null,
            productsItem: [],
            isAutoMoney: false,
            suppliers: [],
            showSuggestions: false,
            filteredSuppliers: [],
            selectedStore: null,
            companies: [],
            selectedCompany: '',
            reviewed: false,
            paymentStatus: 0,
            maxSizeFileNumber: 3
        };
    },
    computed: {
        moneyInWords() {
            return this.money ? this.convertToWords(this.money) + " đồng" : "";
        },
        filteredAddresses() {
            return this.listAddress.filter(listAddress =>
                listAddress.fulladdress.toLowerCase().includes(this.fullbranchaddress.toLowerCase())
            );
        },
        totalAllMoney() {
            return [
                ...(this.productsSummary.totalInventoryMaterials || []),
                ...(this.productsSummary.totalCeremonyMaterials || []),
                ...(this.productsSummary.totalNonInventoryMaterials || []),
                ...(this.productsSummary.totalOther || [])
            ].reduce((sum, item) => sum + (Number(item.money) || 0), 0)
        },
        fillterBillTypesData() {
            return this.$app.billTypes.filter(item => item.value != 0);
        },
        listBillOption() {
            return this.$app.billOptions || [];
        },
    },
    mounted() {
        if (!this.$app.billOptions || this.$app.billOptions.length === 0) {
            this.fetchBillOptions();
        }
        if (this.$app.userInfo.MAX_SIZE_FILE) {
            this.maxSizeFileNumber = this.$app.userInfo.MAX_SIZE_FILE
        }
        document.body.style.overflow = 'hidden'
        this.fetchCompanies();
        this.getNowDateTime()
        this.fetchStores()
        this.getAllProduct()
        this.getListFournisseur()
        setTimeout(() => {

            if (this.typePopup === 'Edit' && this.billdetail) {
                this.paymentStatus = this.billdetail.approvePaymentStatus
                this.reviewed = this.billdetail.reviewed
                this.selectedDepartment = this.billdetail.departments[0].id
                this.company = this.billdetail.company
                this.btnName = 'Cập nhật'
                this.interpretation = this.billdetail.interpretation
                this.money = this.billdetail.expense
                this.selectedOptionPayment = this.billdetail.paymentMethod
                this.branchaddress = this.billdetail.store?.shortaddress
                this.branchCode = this.billdetail.store?.brand?.code || null
                this.fullbranchaddress = this.billdetail.store?.fulladdress
                this.nowDateTime = moment(this.billdetail.paytime).format('YYYY-MM-DDTHH:MM')
                // this.phonenumber = this.billdetail.phoneNumber
                this.billOption = this.billdetail.formOfBill
                this.otherFormOfBill = this.billdetail.otherFormOfBill || ''
                this.selectedBillType = this.billdetail.billType
                this.code = this.billdetail.code
                this.storeCode = this.billdetail.store?.code
                this.$app.userInfo.bankAccountName = this.billdetail.accountName
                this.$app.userInfo.bankAccountNumber = this.billdetail.accountNumber
                this.$app.userInfo.bankName = this.billdetail.bankName
                if (this.billdetail.billType === 1 && this.billOption === 3) {
                    this.products = this.billdetail.paymentGroup
                } else if (this.billdetail.billType === 3) {
                    this.advanceProducts = this.billdetail.paymentGroup
                } else if (this.billdetail.billType === 1 && this.billOption === 1) {
                    this.productsSummary = this.billdetail.paymentGroup
                } else if (this.billdetail.formOfBill === 4 && this.billdetail.billType === 1) {
                    this.detailPayment = this.billdetail.paymentGroup
                    this.companyNumber = this.billdetail.companyNumber
                    this.typeOfGoods = this.billdetail.typeOfGoods
                    this.supplier = this.billdetail.supplier
                    this.supplierAddress = this.billdetail.supplierAddress
                }
            } else {
                this.btnName = 'Tạo mới'
                this.selectedDepartment = this.$app.userInfo.departments[0].id
                if (this.listBillOption && this.listBillOption.length > 0) {
                    this.billOption = this.listBillOption[0].value
                }
            }
        }, 300);
    },
    beforeDestroy() {
        document.body.style.overflow = ''
    },
    methods: {
        async fetchBillOptions() {
            try {
                const res = await this.$axios.get(`${API_URL}/bill-options`);
                if (res.status === 200) {
                    let list = [];
                    if (Array.isArray(res.data)) {
                        list = res.data;
                    } else if (res.data && Array.isArray(res.data.data)) {
                        list = res.data.data.map(item => item.attributes ? { ...item.attributes, id: item.id } : item);
                    }
                    this.$app.billOptions = list.map(item => ({
                        value: Number(item.value),
                        text: item.text || item.label
                    })).sort((a, b) => a.value - b.value);
                }
            } catch (err) {
                console.error("Lỗi khi fetch bill-options:", err);
            }
        },
        async fetchCompanies() {
            try {
                const response = await this.$axios.get(`${API_URL}/companies-list/all`);
                this.companies = response.data.data.map(item => ({
                    name: item.name,
                    value: item.value,
                }));
                const defaultCompany = this.companies.find(c => c.value === 1);
                if (defaultCompany) {
                    this.selectedCompany = defaultCompany.name;
                    this.company = defaultCompany.name;
                }
            } catch (error) {
                console.error('Lỗi khi fetch danh sách công ty:', error);
            }
        },
        async getListFournisseur() {
            try {
                const res = await this.$axios.get(`${API_URL}/fournisseurs/list`);
                this.suppliers = res.data.data.map((i) => ({
                    code: i.code,
                    name: i.name,
                }));
            } catch (error) {
                console.error("Lỗi tải nhà cung cấp:", error);
            }
        },
        onInput(item) {
            const query = item.detail.toLowerCase();
            this.filteredSuppliers = this.suppliers.filter(
                s =>
                    s.code.toLowerCase().includes(query) ||
                    s.name.toLowerCase().includes(query)
            );
            this.showSuggestions = true;
            this.activeItem = item;
        },
        onFocus(item) {
            this.activeItem = item;
            if (item.detail.trim() !== "") this.onInput(item);
            else {
                this.filteredSuppliers = this.suppliers;
                this.showSuggestions = true;
            }
        },
        onBlur() {
            // Cho phép click chọn item (dùng mousedown) mà không bị mất focus
            setTimeout(() => {
                this.showSuggestions = false;
            }, 200);
        },
        selectSupplier(item, supplier) {
            item.detail = `${supplier.code} - ${supplier.name}`;
            this.showSuggestions = false;
        },
        onlyNumber,
        formatNumber,
        updateTotal(e) {
            this.money = unformatNumber(e.target.value);
        },
        updateMoneyItemInDetailPayment(e, index) {
            this.detailPayment[index].money = unformatNumber(e.target.value)
        },

        handleAutoMoney(total) {
            // ✅ Khi TableKitchenForm hoặc TableStoreForm đang hiển thị
            if (
                (this.selectedBillType === 1 && this.billOption === 3) || // KitchenForm
                (this.selectedBillType === 1 && this.billOption === 1)    // StoreForm
            ) {
                this.money = total;
            }
        },

        clearAllTables() {
            if (this.typePopup !== 'Edit' && !this.billdetail) {
                this.products = [
                    { date: new Date().toISOString().slice(0, 10), detail: "", unit: "", quantity: 0, price: 0, money: 0, note: "" }
                ];
                this.productsSummary = {
                    totalNote: "",
                    totalInventoryMaterials: [
                        { date: new Date().toISOString().slice(0, 10), detail: "", unit: "", quantity: 0, price: 0, money: 0, note: "" }
                    ],
                    totalCeremonyMaterials: [
                        { date: new Date().toISOString().slice(0, 10), detail: "", unit: "", quantity: 0, price: 0, money: 0, note: "" }
                    ],
                    totalNonInventoryMaterials: [
                        { date: new Date().toISOString().slice(0, 10), detail: "", unit: "", quantity: 0, price: 0, money: 0, note: "" }
                    ],
                    totalOther: [
                        { date: new Date().toISOString().slice(0, 10), detail: "", unit: "", quantity: 0, price: 0, money: 0, note: "" }
                    ]
                };
                this.advanceProducts = {
                    AdvanceMoney: {
                        money: 0,
                        note: ''
                    },
                    SpentMoney: [
                        { detail: '', money: 0, note: '' }
                    ],
                    noteRemainingAdvance: '',
                    noteExcessAdvance: ''
                };
                this.detailPayment = [
                    {
                        date: new Date().toISOString().slice(0, 10),
                        detail: '',
                        money: 0
                    }
                ];
            }
        },
        async getAllProduct() {
            try {
                const res = await this.$axios.get(`${API_URL}/products/getall`);
                this.productsItem = res.data.data || [];
            } catch (err) {
                console.error("Không thể tải danh sách sản phẩm:", err);
            }
        },
        convertToWords(number) { const units = ["", "một", "hai", "ba", "bốn", "năm", "sáu", "bảy", "tám", "chín"]; const teens = ["mười", "mười một", "mười hai", "mười ba", "mười bốn", "mười lăm", "mười sáu", "mười bảy", "mười tám", "mười chín"]; const tens = ["", "", "hai mươi", "ba mươi", "bốn mươi", "năm mươi", "sáu mươi", "bảy mươi", "tám mươi", "chín mươi"]; function convertThreeDigits(num) { let str = ""; let hundreds = Math.floor(num / 100); let remainder = num % 100; if (hundreds > 0) str += units[hundreds] + " trăm "; if (remainder > 0) { if (remainder < 10) str += units[remainder]; else if (remainder < 20) str += teens[remainder - 10]; else str += tens[Math.floor(remainder / 10)] + (remainder % 10 !== 0 ? " " + units[remainder % 10] : ""); } return str.trim(); } if (number == 0) return "không"; let numStr = parseInt(number).toString(); let numGroups = []; while (numStr.length > 0) { numGroups.unshift(numStr.slice(-3)); numStr = numStr.slice(0, -3); } let words = ""; let scale = ["", "nghìn", "triệu", "tỷ"]; numGroups.forEach((group, index) => { if (parseInt(group) !== 0) { words += convertThreeDigits(parseInt(group)) + " " + scale[numGroups.length - 1 - index] + " "; } }); return words.trim(); },
        addDetailPayment() {
            this.detailPayment.push({ date: new Date().toISOString().slice(0, 10), detail: '', money: '' });
        },
        getTotalMoney(list) {
            return (list || []).reduce((sum, item) => sum + (Number(item.money) || 0), 0);
        },
        changePage(index) {
            this.currentIndex = index;
            this.$nextTick(() => {
                if (this.$refs.scrollWrapper) this.$refs.scrollWrapper.scrollTop = 0;
            });
        },
        onUpdateAddress(data) {
            this.fullbranchaddress = data.fulladdress;
            this.branchaddress = data.shortaddress;
            this.branchCode = data.brand?.code || null;
            this.storeCode = data.code;
            this.selectedStore = data
            this.isShowListAddress = false;
        },
        showListAddessPopup() {
            this.isShowListAddress = true;
        },
        handleFileUpload(event) {
            const files = Array.from(event.target.files);
            const validFiles = [];
            if (this.$app.userInfo.MAX_SIZE_FILE) {
                this.MAX_SIZE = this.$app.userInfo.MAX_SIZE_FILE * 1024 * 1024
            }
            files.forEach(file => {
                if (file.size <= this.MAX_SIZE) {
                    validFiles.push(file);
                } else {
                    this.$notify.error({
                        title: 'Thất bại',
                        message: `File ${file.name} vượt quá giới hạn ${this.maxSizeFileNumber}MB và sẽ không được upload.`
                    });
                }
            });

            this.selectedFile = [...this.selectedFile, ...validFiles];
        },
        closeModal(reload = false) {
            this.isVisible = false;
            setTimeout(() => {
                this.$emit('closed');
                if (reload) this.$emit('reload');
            }, 200);
        },
        getNowDateTime() {
            this.nowDateTime = moment().format('YYYY-MM-DD HH:mm');
        },

        // ================== HELPER ==================
        prepareFilteredProducts() {
            if (this.selectedBillType === 1 && this.billOption === 3) {
                return this.products.filter(p => {
                    return p.detail.trim() || p.money.toString().trim() || p.date.trim() ||
                        p.unit.trim() || p.quantity.toString().trim() || p.price.toString().trim()
                }
                );
            }
            if (this.selectedBillType === 3) {
                return {
                    ...this.advanceProducts,
                    SpentMoney: this.advanceProducts.SpentMoney.filter(i => {
                        return i.detail.trim() || i.money.toString().trim() || i.note.trim()
                    }
                    )
                };
            }
            if (this.selectedBillType === 1 && this.billOption === 1) {
                return this.productsSummary;
            }
            if (this.billOption === 4 && this.selectedBillType === 1) {
                return this.detailPayment;
            }
            return [];
        },
        buildNewData() {
            if (this.billdetail.approvePaymentStatus === 3) {
                this.paymentStatus = 0
            }
            if (this.billOption === 4 && this.selectedBillType === 1) {
                return {
                    department: this.selectedDepartment,
                    paymentMethod: this.selectedOptionPayment,
                    status: 1,
                    paymentGroup: this.filteredProducts,
                    formOfBill: this.billOption,
                    approvePaymentStatus: this.paymentStatus,
                    attachedfile: this.filesContainer,
                    billType: this.selectedBillType,
                    company: this.company,
                    companyNumber: this.companyNumber,
                    typeOfGoods: this.typeOfGoods,
                    supplier: this.supplier,
                    supplierAddress: this.supplierAddress,
                    paytime: this.nowDateTime,
                    expense: this.getTotalMoney(this.detailPayment),
                    code: this.code,
                    accountName: this.$app.userInfo.bankAccountName,
                    accountNumber: this.$app.userInfo.bankAccountNumber,
                    bankName: this.$app.userInfo.bankName,
                    store: this.selectedStore?.id,
                    reviewed: this.reviewed
                };
            }
            return {
                company: this.company,
                department: this.selectedDepartment,
                interpretation: this.interpretation,
                expense: this.money,
                paymentMethod: this.selectedOptionPayment,
                accountName: this.$app.userInfo.bankAccountName,
                accountNumber: this.$app.userInfo.bankAccountNumber,
                bankName: this.$app.userInfo.bankName,
                branchAddress: this.branchaddress,
                branchCode: this.branchCode,
                fullBranchAddress: this.fullbranchaddress,
                storeCode: this.storeCode,
                paytime: this.nowDateTime,
                status: 1,
                paymentGroup: this.filteredProducts,
                formOfBill: this.billOption,
                otherFormOfBill: Number(this.billOption) === 8 ? this.otherFormOfBill : null,
                approvePaymentStatus: this.paymentStatus,
                attachedfile: this.filesContainer,
                billType: this.selectedBillType,
                code: this.code,
                store: this.selectedStore?.id,
                reviewed: this.reviewed
            };
        },

        // ================== API ==================
        async fetchStores() {
            try {
                const response = await this.$axios.get(`${API_URL}/stores/getall`);
                this.listAddress = response.data.map(i => ({
                    shortaddress: i.shortaddress,
                    fulladdress: i.fulladdress,
                    code: i.code
                }));
            } catch (error) {
                console.error("Lỗi khi lấy danh sách cửa hàng:", error);
            }
        },
        async updateBill() {
            if (this.billOption !== 1 && this.billOption !== 3) {
                this.fullbranchaddress = null;
                this.branchaddress = null;
                this.branchCode = null;
                this.storeCode = null;
                this.selectedStore = null
            }
            if (this.selectedOptionPayment === 1) {
                this.accountname = this.accountnumber = this.bankname = null;
            }

            this.filteredProducts = this.prepareFilteredProducts();

            if (this.billdetail.attachedfile) {
                this.filesContainer = [...this.billdetail.attachedfile, ...this.filesContainer];
            }

            this.newData = this.buildNewData();
            try {
                await this.$axios.put(
                    `${API_URL}/bills/update/${this.billdetail.id}`,
                    { type: 'general', data: this.newData },
                    { headers: { 'Content-Type': 'application/json', 'X-Authorization': `Bearer ${this.$app.token}` } }
                );
                this.$notify.success({ title: 'Thành công', message: 'Cập phiếu thành công.' });
                this.closeModal(true);
            } catch (err) {
                const errorMessage = err.response?.data?.error?.message || 'Đã có lỗi xảy ra';
                this.$notify.error({ title: 'Thất bại', message: errorMessage });
                this.closeModal();
            }
        },
        async createNewBill() {
            if (this.billOption !== 1 && this.billOption !== 3) {
                this.fullbranchaddress = null;
                this.branchaddress = null;
                this.branchCode = null;
                this.storeCode = null;
                this.selectedStore = null
            }
            if (this.selectedOptionPayment === 1) {
                this.accountname = this.accountnumber = this.bankname = null;
            }
            if (this.accountname && this.accountnumber && this.bankName &&
                this.$app.userInfo.bankAccountNumber !== this.accountnumber) {
                this.updateBank();
            }

            this.filteredProducts = this.prepareFilteredProducts();
            this.newData = this.buildNewData();
            try {
                const res = await this.$axios.post(
                    `${API_URL}/bill/createBills`,
                    { data: this.newData },
                    { headers: { 'Content-Type': 'application/json', 'X-Authorization': `Bearer ${this.$app.token}` } }
                );
                if (res.data) {
                    this.isloading = false;
                    this.$notify.success({ title: 'Thành công', message: 'Tạo phiếu thành công.' });
                    this.closeModal(true);
                }
            } catch (err) {
                const errorMessage = err.response?.data?.error?.message || 'Đã có lỗi xảy ra';
                this.$notify.error({ title: 'Thất bại', message: errorMessage });
                this.closeModal();
            }
        },
        validateForm() {
            this.errors = {}; // reset lỗi cũ
            let isValid = true;

            // ✅ Kiểm tra loại phiếu
            if (!this.selectedBillType) {
                this.errors.billType = "Vui lòng chọn loại phiếu.";
                isValid = false;
            }

            // ✅ Kiểm tra nhóm phiếu
            if (!this.billOption) {
                this.errors.billOption = "Vui lòng chọn nhóm phiếu.";
                isValid = false;
            }

            // ✅ Kiểm tra tên nhóm phiếu khác nếu chọn Nhóm phiếu = 8 (Khác)
            if (Number(this.billOption) === 8) {
                if (!this.otherFormOfBill || !this.otherFormOfBill.trim()) {
                    this.errors.otherFormOfBill = "Vui lòng nhập tên nhóm phiếu.";
                    isValid = false;
                }
            }

            // ✅ Nếu billOption = 4 & selectedBillType = 1 (phiếu mua hàng)
            if (this.billOption === 4 && this.selectedBillType === 1) {
                if (!this.company) {
                    this.errors.company = "Vui lòng nhập tên công ty.";
                    isValid = false;
                }
                // if (!this.companyNumber) {
                //     this.errors.companyNumber = "Vui lòng nhập số CT.";
                //     isValid = false;
                // }
                // if (!this.nowDateTime) {
                //     this.errors.nowDateTime = "Vui lòng nhập ngày.";
                //     isValid = false;
                // }
                // if (!this.typeOfGoods) {
                //     this.errors.typeOfGoods = "Vui lòng nhập loại hàng hóa.";
                //     isValid = false;
                // }
                if (!this.supplier) {
                    this.errors.supplier = "Vui lòng nhập tên nhà cung cấp.";
                    isValid = false;
                }
                // if (!this.supplierAddress) {
                //     this.errors.supplierAddress = "Vui lòng nhập địa chỉ nhà cung cấp.";
                //     isValid = false;
                // }
                if (!this.selectedOptionPayment) {
                    this.errors.selectedOptionPayment = "Vui lòng chọn hình thức thanh toán.";
                    isValid = false;
                }

                // ✅ validate bảng detailPayment
                if (!this.detailPayment.length || this.getTotalMoney(this.detailPayment) <= 0) {
                    this.errors.detailPayment = "Vui lòng nhập ít nhất một dòng thanh toán.";
                    isValid = false;
                }
            }

            // ✅ Nếu billOption khác (vd: 1,2,3)
            else {
                if (!this.money || this.money <= 0) {
                    this.errors.money = "Vui lòng nhập số tiền.";
                    isValid = false;
                }
                if (!this.interpretation) {
                    this.errors.interpretation = "Vui lòng nhập diễn giải.";
                    isValid = false;
                }

                // Nếu thanh toán qua ngân hàng
                if (this.selectedOptionPayment === '2') {
                    if (!this.$app.userInfo.bankAccountName) {
                        this.errors.accountname = "Vui lòng nhập tên chủ tài khoản.";
                        isValid = false;
                    }
                    if (!this.$app.userInfo.bankAccountNumber) {
                        this.errors.accountnumber = "Vui lòng nhập số tài khoản.";
                        isValid = false;
                    }
                    if (!this.$app.userInfo.bankName) {
                        this.errors.bankname = "Vui lòng nhập tên ngân hàng.";
                        isValid = false;
                    }
                }

                // Nếu billOption = 1 hoặc 3 → cần địa chỉ cửa hàng
                if ((this.billOption === 1 || this.billOption === 3) && !this.fullbranchaddress) {
                    this.errors.fullbranchaddress = "Vui lòng chọn địa chỉ chi nhánh cửa hàng.";
                    isValid = false;
                }
            }

            // ✅ Nếu có lỗi thì return
            if (!isValid) {
                this.$notify.error({
                    title: 'Thất bại',
                    message: 'Vui lòng nhập đầy đủ thông tin.'
                });
                return false;
            }

            this.uploadFileAmazon();
        },

        uploadFileAmazon() {
            this.isloading = true;
            if (this.selectedFile.length) {
                const formData = new FormData();
                this.selectedFile.forEach(file => formData.append('files', file));

                this.$axios.post(`${API_URL}/upload`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                }).then(res => {
                    this.filesContainer = res.data;
                    this.typePopup === 'Edit' ? this.updateBill() : this.createNewBill();
                }).catch(error => {
                    this.$notify.error({ title: 'Thất bại', message: `Lỗi upload:, ${error}` });
                    console.error('Lỗi upload:', error);
                });
            } else {
                this.typePopup === 'Edit' ? this.updateBill() : this.createNewBill();
            }
        },

        removeSelectedFile(index) {
            this.selectedFile.splice(index, 1);
        },

        // 🗑️ Xoá file đã upload lên S3
        async removeUploadedFile(file, index) {
            try {
                const confirmDelete = confirm(`Bạn có chắc muốn xoá file "${file.name}" không?`);
                if (!confirmDelete) return;

                // Gửi request xoá file đến backend
                await this.$axios.delete(`${API_URL}/upload/files/${file.id}`);

                // Xoá khỏi danh sách hiển thị
                this.billdetail.attachedfile.splice(index, 1);

                this.$notify.success({
                    title: 'Thành công',
                    message: `Đã xoá file "${file.name}" thành công.`
                });
            } catch (error) {
                console.error('Lỗi xoá file:', error);
                this.$notify.error({
                    title: 'Thất bại',
                    message: `Không thể xoá file "${file.name}".`
                });
            }
        },

        // ================== BANK ==================
        updateBank() {
            const userEmail = this.$app.userInfo.email;
            const bankAccount = {
                bankAccountName: this.accountname,
                bankAccountNumber: this.accountnumber,
                bankName: this.bankname
            };

            this.$axios.put(`${API_URL}/authuserslog/UpdateUserBank/${userEmail}`, { bankAccount })
                .then(res => {
                    if (res.message == 200) {
                        this.$app.userInfo = {
                            ...this.$app.userInfo,
                            ...res.updateBankAccount
                        };
                        this.$notify.success({ title: 'Thành công', message: 'Cập nhật tài khoản ngân hàng thành công.' });
                    }
                }).catch(err => {
                    this.$notify.error({ title: 'Thất bại', message: `Lỗi Bank update:, ${err}` });
                });
        }
    },
    watch: {
        selectedBillType() {
            this.clearAllTables();
        },
        billOption(newVal) {
            this.clearAllTables();
            if (Number(newVal) !== 8) {
                this.otherFormOfBill = '';
                delete this.errors.otherFormOfBill;
            }
        },
        listBillOption: {
            handler(newVal) {
                if (this.typePopup !== 'Edit' && newVal && newVal.length > 0) {
                    this.billOption = newVal[0].value;
                }
            },
            immediate: true
        },
        selectedCompany(newVal) {
            this.company = newVal || 'HIGHLAND AGRI'; // mặc định HIGHLAND AGRI nếu không chọn
        },
    },
};
</script>

<style scoped>
.no-scrollbar::-webkit-scrollbar {
    display: none;
    /* Ẩn trên Chrome, Safari */
}

.no-scrollbar {
    -ms-overflow-style: none;
    /* Ẩn trên IE, Edge */
    scrollbar-width: none;
    /* Ẩn trên Firefox */
}

@keyframes popupFadeIn {
    0% {
        opacity: 0;
        transform: translateY(10px);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes popupFadeOut {
    0% {
        opacity: 1;
        transform: translateY(0);
    }

    100% {
        opacity: 0;
        transform: translateY(10px);
    }
}

.animate-popupFadeIn {
    animation: popupFadeIn 0.5s forwards;
}

.animate-popupFadeOut {
    animation: popupFadeOut 0.5s forwards;
}
</style>